import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { post } from "common/helpers/HTTP";

import type { LinkedInPost } from "../types";

async function getLinkedInPostRequest(
  workspaceId: string,
  accountId: string,
  postUrl: string,
): Promise<LinkedInPost> {
  return (
    await post(`workspaces/${workspaceId}/accounts/${accountId}/posts`, {
      post_url: postUrl,
    })
  ).post;
}

export default function useLinkedInPost(accountId: string, postUrl: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { leadListSourcesKeys } = getQueryKeys(workspaceId);

  const {
    data: linkedInPost,
    isLoading: isLoadingLinkedInPost,
    error: linkedInPostError,
  } = useQuery({
    queryKey: leadListSourcesKeys.linkedInPost(accountId, postUrl),
    queryFn: () => getLinkedInPostRequest(workspaceId, accountId, postUrl),
    gcTime: 0,
    enabled: !!accountId && !!postUrl,
  });

  return {
    linkedInPost,
    isLoadingLinkedInPost,
    linkedInPostError,
  };
}
